var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.025 12.847 3.57 3.57-1.18 1.178-3.568-3.57a7.47 7.47 0 0 1-4.681 1.642c-4.14 0-7.5-3.36-7.5-7.5s3.36-7.5 7.5-7.5 7.5 3.36 7.5 7.5c0 1.77-.614 3.397-1.64 4.68m-1.672-.618A5.81 5.81 0 0 0 14 8.167a5.83 5.83 0 0 0-5.833-5.834 5.83 5.83 0 0 0-5.833 5.834A5.83 5.83 0 0 0 8.166 14c1.58 0 3.012-.627 4.062-1.646z"
  })));
};
export default SvgSearch;